module.exports = __webpack_public_path__ + "static/img/image19.328ace7a.png";